import { forwardRef } from 'react';
import { IonAccordionGroup } from '@ionic/react';
import { AllieAccordionGroupProps } from './AccordionGroup.types';

export const AllieAccordionGroup = forwardRef<
  HTMLIonAccordionGroupElement,
  AllieAccordionGroupProps
>((props, ref) => <IonAccordionGroup ref={ref} {...props} />);
